module.exports = __webpack_public_path__ + "static/img/profile04.dafe8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/profile04.png
// module id = gsgf
// module chunks = 10